//WMCE-455: Reduced muster initialization -- Introduced Login wrapper to save the LoginCredentials in Provider1
import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Router from '@dbk-legacy/muster/react-router';
import VascoModal from '../screens/auth/vasco/vasco-modal';
import ResetPasswordPage from '../screens/auth/change-password-from-login'

const resetPasswordRouteConfig = {
  '*': {
    component: ResetPasswordPage,
    section: 'resetPassword',
  },
};

class LoginWrapper extends PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div>
        {this.props.vascoauthentication.vascoAuthorised ?
          <Router config={resetPasswordRouteConfig} />
          :
          this.props.children
        }
        {this.props.vascoauthentication.isVascoModalVisible && <VascoModal />}
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    console.log("update happen..login warpper");
    if (this.props.auth.authorised == true && (this.props.auth.unAuthorisedUser != null && this.props.auth.unAuthorisedUser == false) && this.props.auth.authenticationJson != prevProps.auth.authenticationJson) {
      this.props.onLoginChange(this.props.auth.authenticationJson);
    }
    if (prevProps.languages.destLanguage && prevProps.languages.destLanguage !== this.props.languages.destLanguage) {
      this.props.onLanguageChange();
    }
  }
}
export default createContainer({
  $queries: {
    auth: {
      authHeader: true,
      passwordExpired: true,
      sessionId: true,
      userId: true,
      lastSession: true,
      lastSessionTZ: true,
      userGroup: true,
      authorised: true,
      authenticationJson: true,
      unAuthorisedUser: true
    },
    vascoauthentication: {
      isVascoModalVisible: true,
      vascoAuthorised: true,
    },
    languages: {
      destLanguage: true,
    },
  },
})(LoginWrapper);
